import styled from "@emotion/styled";
import { PLANS_COMPONENT_WIDTH } from "constants/pricing-sizes";
import { MD } from "constants/vp-sizes";
export const StyledFeaturesTablePricingComponent = styled.div`
  width: ${`${PLANS_COMPONENT_WIDTH}px`};
  margin: 0 auto;

  @media (max-width: ${MD}px) {
    width: 100%;
    max-width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }
`;
